import React from "react";
import { IconButton, Tooltip, useTheme } from "@mui/material";
import { LinkRounded } from "@mui/icons-material";
import { usePostHog } from "posthog-js/react";
import { COPY_MESSAGE_LINK } from "../../../../../utils/posthogEvents";
import { useSnackbar } from "notistack";

function CopyMessageLink({ query }) {
  const posthog = usePostHog();
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const handleCopyMessageLink = () => {
    const url = generateShareUrl(query["message_id"]);
    handleCopy(url, "Copied message link to clipboard");
    posthog.capture(COPY_MESSAGE_LINK);
  };

  const generateShareUrl = (messageId) => {
    const url = new URL(window.location.href);

    // Set the messageId as a query parameter
    url.searchParams.set("messageId", messageId);

    return url.toString(); // Return the complete URL as a string
  };

  const handleCopy = (content, toastMessage) => {
    window.navigator.clipboard.writeText(content);
    enqueueSnackbar(toastMessage);
  };

  return (
    <Tooltip title="Copy Message Link">
      <IconButton
        size="small"
        sx={{ color: theme.palette.action.active, ml: 1 }}
        onClick={handleCopyMessageLink}>
        <LinkRounded sx={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  );
}

export default CopyMessageLink;
